export const CAPSULE_UA_SUBSTR = 'Capsule';
export const AKEY_UA_SUBSTR = 'AKEY';
export const VOSKHOD_UA_SUBSTR = 'VOSKHOD';
export const LUNOKHOD_UA_SUBSTR = 'LUNOKHOD';
/**
 * Проверка по юзерагенту на сервере
 */
export const isAkeyWebview = (userAgent) => userAgent.includes(CAPSULE_UA_SUBSTR) ||
    userAgent.includes(AKEY_UA_SUBSTR) ||
    userAgent.includes(VOSKHOD_UA_SUBSTR) ||
    userAgent.includes(LUNOKHOD_UA_SUBSTR);
/**
 * @deprecated Использовать isAkeyWebview из @alfa-bank/newclick-helpers/utils/akey/is-akey-webview
 */
export const isAkeyUA = (userAgent) => userAgent.includes(AKEY_UA_SUBSTR);
/**
 * @deprecated Использовать isAkeyWebview из @alfa-bank/newclick-helpers/utils/akey/is-akey-webview
 */
export const isVoskhodUA = (userAgent) => userAgent.includes(VOSKHOD_UA_SUBSTR);
